<!doctype html>
<html lang="pt-BR" [attr.data-theme]="theme()">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover">
  <meta name="description" content="Documentação da API de Integração de Leads da VWFS.">
  <meta name="robots" content="noindex, nofollow">

  <title>API de Leads por Token | VWFS</title>

  <link rel="icon" href="/assets/images/logo-documentacao.svg" type="image/svg+xml">

  <script src="assets/js/app.js"></script>
</head>

<body>

  <script src="/assets/js/documentacao-api.js"></script>

  <a class="skip-link" href="#conteudo">Ir para o conteúdo</a>

  <header class="topbar">
    <div class="topbar__brand">
      <button id="menuButton" class="icon-button mobile-only" type="button" aria-label="Abrir menu"
        aria-controls="sidebar" aria-expanded="false" (click)="toggleMenu()">
        <span aria-hidden="true">☰</span>
      </button>

      <a routerLink="/" class="brand" style="cursor:pointer">
        <img class="brand__logo" src="assets/images/logo_novo_3.svg">
      </a>
    </div>

    <div class="topbar__actions">
      <!-- <div class="environment" title="Ambiente documentado">
        <span class="status-dot" aria-hidden="true"></span>
        UAT
      </div> -->

      <button id="themeButton" class="icon-button" type="button" aria-label="Alternar tema" title="Alternar tema"
        (click)="toggleTheme()">
        <span aria-hidden="true">◐</span>
      </button>
    </div>
  </header>

  <div class="layout">
    <aside id="sidebar" class="sidebar" [class.open]="sidebarOpen()" aria-label="Navegação principal">
      <div class="sidebar__search">
        <label class="sr-only" for="searchInput">
          Pesquisar na documentação
        </label>

        <span aria-hidden="true">⌕</span>

        <input #searchInput id="searchInput" type="search" placeholder="Pesquisar..." autocomplete="off"
          [value]="navigationSearch()" (input)="updateNavigationSearch($any($event.target).value)">
      </div>

      <!-- <nav id="docNavigation" class="navigation">

        <p class="navigation__group">Começando</p>

        <a #navLink routerLink="." fragment="introducao" [hidden]="!matchesSearch('Introdução')">
          Introdução
        </a>

        <a #navLink routerLink="." fragment="pre-requisitos" [hidden]="!matchesSearch('Pré-requisitos')">
          Pré-requisitos
        </a>

        <a #navLink routerLink="." fragment="ambientes" [hidden]="!matchesSearch('Ambientes e URLs')">
          Ambientes e URLs
        </a>

        <a #navLink routerLink="." fragment="autenticacao" [hidden]="!matchesSearch('Autenticação')">
          Autenticação
        </a>

        <a #navLink routerLink="." fragment="regra-dn" [hidden]="!matchesSearch('Regra de DN')">
          Regra de DN
        </a>

        <a #navLink routerLink="." fragment="primeiros-passos" [hidden]="!matchesSearch('Primeiros passos')">
          Primeiros passos
        </a>

        ...

        <p class="empty-search" [hidden]="hasVisibleLinks()">
          Nenhum tópico encontrado.
        </p>

      </nav> -->
      <nav id="docNavigation" class="navigation">
        <a #navLink routerLink="." [hidden]="!matchesSearch('Introdução')" fragment="introducao"
          [class.activeMenu]="activeMenu() === 'introducao'" (click)="activeMenu.set('introducao')">
          Introdução
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Pré-requisitos')" fragment="pre-requisitos"
          [class.activeMenu]="activeMenu() === 'pre-requisitos'" (click)="activeMenu.set('pre-requisitos')">
          Pré-requisitos
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Ambientes e URLs')" fragment="ambientes"
          [class.activeMenu]="activeMenu() === 'ambientes'" (click)="activeMenu.set('ambientes')">
          Ambientes e URLs
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Autenticação')" fragment="autenticacao"
          [class.activeMenu]="activeMenu() === 'autenticacao'" (click)="activeMenu.set('autenticacao')">
          Autenticação
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Regra de DN')" fragment="regra-dn"
          [class.activeMenu]="activeMenu() === 'regra-dn'" (click)="activeMenu.set('regra-dn')">
          Regra de DN
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Primeiros passos')" fragment="primeiros-passos"
          [class.activeMenu]="activeMenu() === 'primeiros-passos'" (click)="activeMenu.set('primeiros-passos')">
          Primeiros passos
        </a>

        <p [hidden]="!matchesSearch('Endpoints')" class="navigation__group">Endpoints</p>

        <a #navLink routerLink="." [hidden]="!matchesSearch('Listar todos')" fragment="listar-todos"
          [class.activeMenu]="activeMenu() === 'listar-todos'" (click)="activeMenu.set('listar-todos')">
          <span class="method method--get">GET</span>
          Listar todos
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Listar com paginação')" fragment="listar-paginado"
          [class.activeMenu]="activeMenu() === 'listar-paginado'" (click)="activeMenu.set('listar-paginado')">
          <span class="method method--get">GET</span>
          Listar com paginação
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Filtrar por DN')" fragment="filtrar-dn"
          [class.activeMenu]="activeMenu() === 'filtrar-dn'" (click)="activeMenu.set('filtrar-dn')">
          <span class="method method--get">GET</span>
          Filtrar por DN
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('DN com paginação')" fragment="filtrar-dn-paginado"
          [class.activeMenu]="activeMenu() === 'filtrar-dn-paginado'" (click)="activeMenu.set('filtrar-dn-paginado')">
          <span class="method method--get">GET</span>
          DN com paginação
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('DN e período')" fragment="filtrar-dn-data"
          [class.activeMenu]="activeMenu() === 'filtrar-dn-data'" (click)="activeMenu.set('filtrar-dn-data')">
          <span class="method method--get">GET</span>
          DN e período
        </a>

        <p [hidden]="!matchesSearch('Referência')" class="navigation__group">Referência</p>

        <a #navLink routerLink="." [hidden]="!matchesSearch('Estrutura JSON')" fragment="resposta-json"
          [class.activeMenu]="activeMenu() === 'resposta-json'" (click)="activeMenu.set('resposta-json')">
          Estrutura JSON
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Dicionário de dados')" fragment="dicionario"
          [class.activeMenu]="activeMenu() === 'dicionario'" (click)="activeMenu.set('dicionario')">
          Dicionário de dados
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Transformações')" fragment="transformacoes"
          [class.activeMenu]="activeMenu() === 'transformacoes'" (click)="activeMenu.set('transformacoes')">
          Transformações
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Erros')" fragment="erros"
          [class.activeMenu]="activeMenu() === 'erros'" (click)="activeMenu.set('erros')">
          Erros
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Deduplicação')" fragment="deduplicacao"
          [class.activeMenu]="activeMenu() === 'deduplicacao'" (click)="activeMenu.set('deduplicacao')">
          Deduplicação
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Frequência de consulta')" fragment="frequencia"
          [class.activeMenu]="activeMenu() === 'frequencia'" (click)="activeMenu.set('frequencia')">
          Frequência de consulta
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Perguntas frequentes')" fragment="faq"
          [class.activeMenu]="activeMenu() === 'faq'" (click)="activeMenu.set('faq')">
          Perguntas frequentes
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Histórico de versões')" fragment="historico"
          [class.activeMenu]="activeMenu() === 'historico'" (click)="activeMenu.set('historico')">
          Histórico de versões
        </a>
        <a #navLink routerLink="." [hidden]="!matchesSearch('Contato e disponibilização de credenciais')"
          fragment="contato" [class.activeMenu]="activeMenu() === 'contato'" (click)="activeMenu.set('contato')">
          Contato e credenciais
        </a>

        <p class="empty-search" [hidden]="hasVisibleLinks()">
          Nenhum tópico encontrado.
        </p>
      </nav>
    </aside>

    <button id="sidebarBackdrop" class="sidebar-backdrop" type="button" aria-label="Fechar menu" hidden></button>

    <main id="conteudo" class="content">
      <div class="content__main">
        <section id="introducao" class="doc-section hero">
          <div class="eyebrow">Tutorial de Integração</div>

          <h1>API de Leads por Token</h1>

          <h3>1. Introdução</h3>
          <p class="lead">
            A API de Integração de Leads da VWFS permite que sistemas externos consultem
            leads de concessionárias (DNs) de forma segura e controlada. <br>
            Cada integrador recebe um token único que determina quais concessionárias
            (DNs) ele pode consultar. A API retorna os dados em formato JSON, onde cada
            lead é um objeto com campos nomeados conforme o dicionário desta
            documentação.
          </p>

          <h4>O que você vai conseguir fazer </h4>
          <p class="lead">
            • Buscar todos os leads dos seus DNs autorizados <br>
            • Filtrar leads por filtros específicos como DN e data do lead<br>
            • Navegar pelo resultado com paginação de forma opcional<br>
            • Receber dados dos leads da Financial Services, como a de:<br>
            • Simulações Online de Financiamento: leads originados pelos simuladores de
            financiamento online como: OfertasVW e Sempre Novo<br>
            • Proposta Aprovada: propostas aprovadas há mais de 31 dias sem conversão
            em contrato<br>
            • Período de Recompra: clientes em período de recompra que estão a três
            meses do encerramento do contrato ou, liquidado antecipadamente<br>
            • Simulações Online de Assinatura: leads originados pelos simuladores de
            assinatura online como: Sign&Drive
          </p>

          <h3>2. Pré-requisitos</h3>
          <p class="lead">
            Antes de começar, você precisa:<br><br>
            1. Token de integração — solicite à equipe VWFS o token x-api-key para o seu
            grupo de DNs<br>
            2. Lista de DNs autorizadas — confirme com a VWFS quais DNs estão
            vinculadas ao seu token<br>
            3. Cliente HTTP — qualquer ferramenta ou biblioteca capaz de fazer requisições
            GET com headers (cURL, Postman, Insomnia, ou código em qualquer
            linguagem)<br>
            4. Acesso de rede ao ambiente de destino — certifique-se que sua máquina ou
            servidor consegue atingir os endereços abaixo
          </p>

          <h3>3. Ambientes e URLs base</h3>
          <span class="lead">
            <table>
              <tr>
                <td>Ambiente</td>
                <td>URL base</td>
                <td>Protocolo</td>
                <td>Porta</td>
              </tr>
              <tr>
                <td>UAT</td>
                <td>https://bff-leads.cons.pp.cld.bancovw.com.br/</td>
                <td>HTTPS</td>
                <td>443</td>
              </tr>
            </table>
          </span>
          <span class="lead">

            Exemplos de URL completa<br>
            <h5>Paginação — página 1, 50 resultados (UAT)</h5>
            GET <br>
            https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/pag/1/results/50 <br>
            <h5>Filtrar pela DN 1117 (UAT) </h5>
            GET <br>
            https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/dn/1117<br>
            <h5>Filtrar pela DN 1117 com paginação (UAT)</h5>
            GET <br>
            https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/dn/1117/pag/1/res
            ults/50<br>
          </span>

          <h3>4. Autenticação</h3>
          <p class="lead">
            Toda requisição precisa incluir o header x-api-key com o token fornecido pela
            VWFS.<br>
            x-api-key: SEU_TOKEN_AQUI <br>
            Exemplo com cURL: <br>
            curl -H "x-api-key: SEU_TOKEN_AQUI" \ <br>
            "https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads"<br>

          <p class="lead">
            Exemplo com Postman:<br>
            Abra a aba Headers <br>
            Adicione a chave x-api-key <br>
            Informe o valor do token no campo Value <br>
            O token deve ser enviado somente no header HTTP. Não envie como parâmetro
            de URL nem no corpo da requisição.<br>
          </p>


          <section id="regra-dn" class="doc-section">
            <h3>5. Regra de DN — o que você pode consultar</h3>

            <span>
              Seu token está vinculado a um grupo de DNs. Você só pode consultar as DNs que
              fazem parte do seu grupo.
              <h4>Exemplo prático:</h4>
              Se o seu token tem as DNs 1117 e 1118 autorizadas:
            </span>

            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>O que você faz</th>
                    <th>Resultado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>GET /api/integration/leads</code></td>
                    <td>Retorna leads das DNs 1117 e 1118</td>
                  </tr>
                  <tr>
                    <td>
                      <code>GET /api/integration/leads/dn/1117</code>
                    </td>
                    <td>Retorna apenas leads da DN 1117</td>
                  </tr>
                  <tr>
                    <td>
                      <code>GET /api/integration/leads/dn/1118</code>
                    </td>
                    <td>Retorna apenas leads da DN 1118</td>
                  </tr>
                  <tr>
                    <td>
                      <code>GET /api/integration/leads/dn/1200</code>
                    </td>
                    <td><span class="status status--error">Erro 403</span> DN não autorizada</td>
                  </tr>
                  <tr>
                    <td>
                      <code>GET /api/integration/leads/dn/1200/dt/2026 03-30/2026-04-29 </code>
                    </td>
                    <td>Retorna apenas leads da DN 1118 no período entre 30/mar/2026 e 29/04/2026 </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="notice notice--info">
              Importante: não será possível a visualização de dados de DNs que não estão no
              seu grupo, mesmo que tente forçar pela URL.<br>
              As informações são consumíveis sempre a partir do momento que é feita a
              consulta.
            </div>
          </section>

          <section id="primeiros-passos" class="doc-section">
            <h3>6. Passo a passo — primeiros passos</h3>

            <ol class="steps steps--cards">
              <li>
                <strong>Verifique o token</strong>
                <p>
                  Faça uma chamada com apenas um resultado para confirmar a
                  autenticação.
                </p>
                <code>GET /api/integration/leads/pag/1/results/1</code>
                <p>
                  curl -H "x-api-key: SEU_TOKEN_AQUI" \ <br>
                  https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/pag/1/results/1<br>
                  Se receber um JSON com o campo pag e results, o token está válido.
                </p>
              </li>

              <li>
                <strong>Descubra o volume total</strong>
                <p>
                  Use o endpoint paginado para ver quantos leads existem: <br>
                  curl -H "x-api-key: SEU_TOKEN_AQUI" \ <br>
                  https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/pag/1/results/1<br>
                  O campo totalResults no retorno indica o total de leads disponíveis.
                </p>
              </li>

              <li>
                <strong>Itere pelas páginas </strong>
                <p>
                  Com results = 100 por página, percorra de pag=1 até pag=totalPag:
                </p>
                <p>
                  GET /api/integration/leads/pag/1/results/100 -> primeira página
                </p>
                <p>
                  GET /api/integration/leads/pag/2/results/100 -> segunda página
                </p>
                <!-- <p ngNonBindable>
                  'GET /api/integration/leads/pag/{totalPag}/results/100 -> última página'
                </p> -->
              </li>

              <li>
                <strong>Filtre por DN se necessário</strong>
                <p>Se quiser apenas uma DN específica, use:</p>
                <p>GET /api/integration/leads/dn/1117/pag/1/results/100 </p>
              </li>
              <li>
                <strong>Filtre por DN e data se necessário</strong>
                <p>Se quiser apenas uma DN específica, use: </p>
                <p>GET /api/integration/leads/dn/1117/dt/2026-03-30/2026-04-29/pag/1/results/100 </p>
              </li>
            </ol>

            <h3>7. Passo a passo — primeiros passos</h3>
            <strong>7.1 Listar todos os leads (sem paginação) </strong>
            <p>Retorna todos os leads de todos os DNs autorizados para o seu token em uma
              única resposta.</p>
            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Item </th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>Método</code></td>
                    <td>GET </td>
                  </tr>
                  <tr>
                    <td><code>URL </code></td>
                    <!-- <td ngNonBindable>{baseUrl}/api/integration/leads </td> -->
                  </tr>
                  <tr>
                    <td><code>Header </code></td>
                    <td>x-api-key: SEU_TOKEN</td>
                  </tr>
                  <tr>
                    <td><code>Retorno </code></td>
                    <td>Array de objetos JSON </td>
                  </tr>
                </tbody>
              </table>
            </div>


            <p>
            <p><strong>Requisição</strong></p>
            <div class="api-response-container">
              <div class="api-header">
                <span class="method get">GET</span>
                <span class="endpoint">/api/integration/leads</span>
                <span class="status-badge">200 OK</span>
              </div>
              <!-- <div class="code-block">
                <pre>
                  <code>
                    [
                      {{ '{' }}
                        "idLead": "10042",
                        "dtCadastro": "23/04/2026 14:30:00",
                        "cdCampanha": "VWF-2026-001",
                        "nmCampanha": "Campanha Financiamento Varejo Q1",
                        "nmTipoCampanha": "Financiamento",
                        "idStatusLead": "Novo",
                        "cdCpfCnpj": "12345678901",
                        "cdDn": "1117",
                        "tpPessoa": "Física",
                        "nmNome": "João da Silva",
                        "nmEmail": "joao.silva@email.com",
                        "nrDddCel": "11",
                        "nrTelefoneCel": "999999999",
                        "vlPreco": "75000.00",
                        "vlFinanciado": "60000.00",
                        "vlParcela": "1250.00",
                        "qtPrazo": "48",
                        "tpSegmento": "Varejo"
                      {{ '}' }}
                    ]
                  </code>
                </pre>
              </div> -->
            </div>

            <div class="code-panel">
              <div class="code-panel__header">
                <span>JSON</span>
                <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
              </div>

              <pre>
              <code>
                [
                  {{ '{' }}
                    "idLead": "10042",
                    "dtCadastro": "23/04/2026 14:30:00",
                    "cdCampanha": "VWF-2026-001",
                    "nmCampanha": "Campanha Financiamento Varejo Q1",
                    "nmTipoCampanha": "Financiamento",
                    "idStatusLead": "Novo",
                    "cdCpfCnpj": "12345678901",
                    "cdDn": "1117",
                    "tpPessoa": "Física",
                    "nmNome": "João da Silva",
                    "nmEmail": "joao.silva@email.com",
                    "nrDddCel": "11",
                    "nrTelefoneCel": "999999999",
                    "vlPreco": "75000.00",
                    "vlFinanciado": "60000.00",
                    "vlParcela": "1250.00",
                    "qtPrazo": "48",
                    "tpSegmento": "Varejo"
                  {{ '}' }}
                ]
              </code>
            </pre>
            </div>

            <p>Use este endpoint quando quiser importar todos os dados de uma só vez. Para
              volumes grandes, prefira o endpoint com paginação.</p>

            <strong>7.1 Listar todos os leads (sem paginação) </strong>
            "idLead": "10042",
            "dtCadastro": "23/04/2026 14:30:00",
            "cdCampanha": "VWF-2026-001",
          </section>

          <p class="lead">
            Consulte leads de concessionárias autorizadas com autenticação por
            token, filtros por DN e data e paginação opcional.
          </p>

          <div class="notice notice--warning">
            <strong>Segurança:</strong>
            nunca publique um token real nesta documentação. Todos os exemplos
            usam o valor fictício <code>SEU_TOKEN_AQUI</code>.
          </div>

          <div class="overview-grid">
            <article class="overview-card">
              <span class="overview-card__label">URL base - UAT</span>

              <code>
                [bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br)
              </code>
            </article>

            <article class="overview-card">
              <span class="overview-card__label">Autenticação</span>
              <code>x-api-key</code>
            </article>

            <article class="overview-card">
              <span class="overview-card__label">Formato</span>
              <code>application/json</code>
            </article>

            <article class="overview-card">
              <span class="overview-card__label">Versão do documento</span>
              <code>0.3</code>
            </article>
          </div>

          <h2>O que a integração permite</h2>

          <ul class="feature-list">
            <li>Buscar leads de todas as DNs autorizadas para o token.</li>
            <li>Filtrar os resultados por DN e período de cadastro.</li>
            <li>Navegar pelos resultados utilizando paginação opcional.</li>
            <li>
              Consumir leads de Simulação Online, Proposta Aprovada e Período
              de Recompra.
            </li>
          </ul>
        </section>

        <section id="pre-requisitos" class="doc-section">
          <h2>Pré-requisitos</h2>

          <p>Antes de iniciar a integração, tenha disponíveis:</p>

          <ol class="steps">
            <li>
              <strong>Token de integração:</strong>
              solicite à equipe VWFS o token enviado no header
              <code>x-api-key</code>.
            </li>
            <li>
              <strong>Lista de DNs:</strong>
              confirme quais concessionárias estão vinculadas ao token.
            </li>
            <li>
              <strong>Cliente HTTP:</strong>
              use cURL, Postman, Insomnia ou uma biblioteca HTTP.
            </li>
            <li>
              <strong>Acesso de rede:</strong>
              verifique se o servidor consegue acessar o ambiente UAT.
            </li>
          </ol>
        </section>

        <section id="ambientes" class="doc-section">
          <h2>Ambientes e URLs</h2>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Ambiente</th>
                  <th>URL base</th>
                  <th>Protocolo</th>
                  <th>Porta</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span class="badge badge--uat">UAT</span></td>
                  <td>
                    <code>
                      [bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br)
                    </code>
                  </td>
                  <td>HTTPS</td>
                  <td>443</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="notice notice--info">
            A documentação recebida informa apenas o ambiente UAT. Inclua a URL
            de produção somente depois de ela ser oficialmente disponibilizada.
          </div>
        </section>

        <section id="autenticacao" class="doc-section">
          <h2>Autenticação</h2>

          <p>
            Toda requisição deve incluir o header <code>x-api-key</code> com o
            token fornecido pela VWFS.
          </p>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>Header HTTP</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>x-api-key: SEU_TOKEN_AQUI</code></pre>
          </div>

          <h3>Exemplo com cURL</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>Shell</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>curl --request GET \
  --url "[bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads)" \
  --header "Accept: application/json" \
  --header "x-api-key: SEU_TOKEN_AQUI"</code></pre>
          </div>

          <div class="notice notice--danger">
            <strong>Não envie o token</strong> na URL, no corpo da requisição,
            em capturas de tela, repositórios públicos ou arquivos JavaScript
            executados no navegador.
          </div>



        </section>





        <section id="listar-todos" class="doc-section endpoint">
          <div class="endpoint__title">
            <span class="method method--get">GET</span>
            <div>
              <h2>Listar todos os leads</h2>
              <code>/api/integration/leads</code>
            </div>
          </div>

          <p>
            Retorna todos os leads de todas as DNs autorizadas em uma única
            resposta.
          </p>

          <div class="endpoint-meta">
            <span><strong>Autenticação:</strong> x-api-key</span>
            <span><strong>Resposta:</strong> array JSON</span>
          </div>

          <h3>Requisição</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>cURL</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>curl --request GET \
  --url "[bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads)" \
  --header "Accept: application/json" \
  --header "x-api-key: SEU_TOKEN_AQUI"</code></pre>
          </div>

          <h3>Resposta 200</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>JSON</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre>
              <code>[
                {{ '{' }}
                  "idLead": "10042",
                  "dtCadastro": "23/04/2026 14:30:00",
                  "cdCampanha": "VWF-2026-001",
                  "nmCampanha": "Campanha Financiamento Varejo Q1",
                  "nmTipoCampanha": "Financiamento - Simulação Online",
                  "idStatusLead": "Novo",
                  "cdCpfCnpj": "00000000000",
                  "cdDn": "1117",
                  "tpPessoa": "Física",
                  "nmNome": "Cliente Exemplo",
                  "nmEmail": "cliente@example.com",
                  "nrDddCel": "11",
                  "nrTelefoneCel": "900000000",
                  "vlPreco": "75000.00",
                  "vlFinanciado": "60000.00",
                  "vlParcela": "1250.00",
                  "qtPrazo": "48",
                  "tpSegmento": "Varejo"
                {{ '}' }}
              ]</code>
            </pre>
          </div>

          <p>Use este endpoint quando quiser importar todos os dados de uma só vez. Para volumes grandes, prefira o
            endpoint com paginação.</p>
          <p><strong>7.2 Listar com paginação</strong></p>
          <p>Retorna leads de todos os DNs autorizados, divididos em páginas.</p>


          <div class="notice notice--warning">
            Para volumes grandes, utilize o endpoint paginado.
          </div>
        </section>

        <section id="listar-paginado" class="doc-section endpoint">
          <div class="endpoint__title">
            <span class="method method--get">GET</span>
            <div>
              <h2>7.2 Listar com paginação </h2>
              <!-- <code ngNonBindable> '/api/integration/leads/pag/{pag}/results/{results}' </code> -->
            </div>
          </div>

          <p>
            Retorna os leads das DNs autorizadas divididos em páginas.
          </p>

          <h3>Parâmetros de caminho</h3>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Parâmetro</th>
                  <th>Tipo</th>
                  <th>Regra</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>pag</code></td>
                  <td>Inteiro</td>
                  <td>Obrigatório. Deve começar em 1.</td>
                </tr>
                <tr>
                  <td><code>results</code></td>
                  <td>Inteiro</td>
                  <td>Obrigatório. Mínimo 1 e máximo 200.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>Requisição</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>cURL</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>curl --request GET \
  --url "[bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/pag/1/results/50)" \
  --header "Accept: application/json" \
  --header "x-api-key: SEU_TOKEN_AQUI"</code></pre>
          </div>

          <h3>Resposta 200</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>JSON</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre>
            {{ '{' }}
              "pag": 1,
              "totalPag": 14,
              "totalResults": 678,
              "pagResults": 50,
              "results": [
                  {{ '{' }}
                    "idLead": "10042",
                    "dtCadastro": "23/04/2026 14:30:00",
                    "nmNome": "Cliente Exemplo",
                    "cdDn": "1117"
                  {{ '}' }}
              ]
            {{ '}' }}
            </pre>
          </div>
        </section>

        <section id="filtrar-dn" class="doc-section endpoint">
          <div class="endpoint__title">
            <span class="method method--get">GET</span>
            <div>
              <h2>Filtrar por DN</h2>
              <code ngNonBindable> '/api/integration/leads/dn/"{{ '{' }}"dn"{{ '}' }}"' </code>
            </div>
          </div>

          <p>
            Retorna todos os leads de uma DN específica autorizada para o token.
          </p>

          <h3>Parâmetros de caminho</h3>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Parâmetro</th>
                  <th>Tipo</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>dn</code></td>
                  <td>Numérico</td>
                  <td>Código de uma DN vinculada ao token.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>cURL</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>curl --request GET \
  --url "[bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/dn/1117)" \
  --header "Accept: application/json" \
  --header "x-api-key: SEU_TOKEN_AQUI"</code></pre>
          </div>

          <h3>DN não autorizada</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>JSON - 403</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre ngNonBindable><code ngNonBindable>

  "error": "DN_NOT_AUTHORIZED",
  "message": "A DN informada não está autorizada para este token",
  "timestamp": "2026-04-23T14:30:00Z"

</code>
</pre>
          </div>
        </section>

        <section id="filtrar-dn-paginado" class="doc-section endpoint">
          <div class="endpoint__title">
            <span class="method method--get">GET</span>
            <div>
              <h2>Filtrar por DN com paginação</h2>
              <!-- <code>
                '/api/integration/leads/dn/{dn}/pag/{pag}/results/{results}'
              </code> -->
            </div>
          </div>

          <p>
            Combina a restrição por DN com os metadados e controles de
            paginação.
          </p>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>cURL</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>curl --request GET \
  --url "[bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/dn/1117/pag/2/results/100)" \
  --header "Accept: application/json" \
  --header "x-api-key: SEU_TOKEN_AQUI"</code></pre>
          </div>
        </section>

        <section id="filtrar-dn-data" class="doc-section endpoint">
          <div class="endpoint__title">
            <span class="method method--get">GET</span>
            <div>
              <h2>Filtrar por DN e período</h2>
              <code>
                <!-- '/api/integration/leads/dn/{dn}/dt/{dataIni}/{dataFim}/pag/{pag}/results/{results}' -->
              </code>
            </div>
          </div>

          <p>
            Filtra os leads de uma DN pela data de cadastro e permite paginar o
            resultado.
          </p>

          <div class="notice notice--warning">
            Este endpoint aparece nos exemplos e nas perguntas frequentes do
            documento, mas não consta na lista intitulada "As 4 chamadas
            disponíveis". Confirme sua assinatura final com a equipe da API.
          </div>

          <h3>Parâmetros</h3>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Parâmetro</th>
                  <th>Formato</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>dn</code></td>
                  <td>Numérico</td>
                  <td>DN autorizada.</td>
                </tr>
                <tr>
                  <td><code>dataIni</code></td>
                  <td>yyyy-MM-dd</td>
                  <td>Data inicial inclusiva.</td>
                </tr>
                <tr>
                  <td><code>dataFim</code></td>
                  <td>yyyy-MM-dd</td>
                  <td>Data final inclusiva.</td>
                </tr>
                <tr>
                  <td><code>pag</code></td>
                  <td>Inteiro</td>
                  <td>Página, começando em 1.</td>
                </tr>
                <tr>
                  <td><code>results</code></td>
                  <td>Inteiro</td>
                  <td>Entre 1 e 200.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>cURL</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code>curl --request GET \
  --url "[bff-leads.cons.pp.cld.bancovw.com.br](https://bff-leads.cons.pp.cld.bancovw.com.br/api/integration/leads/dn/1117/dt/2026-03-30/2026-04-29/pag/1/results/100)" \
  --header "Accept: application/json" \
  --header "x-api-key: SEU_TOKEN_AQUI"</code></pre>
          </div>
        </section>

        <section id="resposta-json" class="doc-section">
          <h2>Estrutura da resposta JSON</h2>

          <h3>Endpoints sem paginação</h3>

          <p>Retornam diretamente um array de leads:</p>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>JSON</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre>
              <code>
              [
                {{ '{' }}
                  "idLead": "10042",
                  "nmNome": "Cliente Exemplo"
                {{ '}' }},
                {{ '{' }}
                  "idLead": "10043",
                  "nmNome": "Outro Cliente"
                {{ '}' }}
              ]
              </code>
            </pre>
          </div>

          <h3>Endpoints com paginação</h3>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Campo</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>pag</code></td>
                  <td>Página atual.</td>
                </tr>
                <tr>
                  <td><code>totalPag</code></td>
                  <td>Total de páginas disponíveis.</td>
                </tr>
                <tr>
                  <td><code>totalResults</code></td>
                  <td>Total de registros sem paginação.</td>
                </tr>
                <tr>
                  <td><code>pagResults</code></td>
                  <td>Quantidade de registros na página atual.</td>
                </tr>
                <tr>
                  <td><code>results</code></td>
                  <td>Array de leads.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>Regras dos valores</h3>

          <ul class="feature-list">
            <li>Todos os campos são retornados como strings.</li>
            <li>Campos sem valor retornam <code>""</code>, e não <code>null</code>.</li>
            <li>Datas gerais usam <code>dd/MM/yyyy HH:mm:ss</code>.</li>
            <li><code>dtNascimento</code> usa <code>dd/MM/yyyy</code>.</li>
            <li>Decimais usam ponto, como em <code>"1250.00"</code>.</li>
          </ul>

          <h3>Ordenação</h3>

          <ul class="feature-list">
            <li>
              Consultas com DN específica: <code>dtCadastro</code> decrescente.
            </li>
            <li>
              Consultas sem DN: DN crescente e, depois, registros mais recentes
              primeiro.
            </li>
            <li>
              O FAQ também informa desempate por <code>idLead</code>
              decrescente.
            </li>
          </ul>
        </section>

        <section id="dicionario" class="doc-section">
          <h2>Dicionário de dados</h2>

          <p>
            Use a busca abaixo para localizar um campo da resposta.
          </p>

          <label class="field-search">
            <span class="sr-only">Pesquisar campo</span>
            <!-- <input id="fieldSearch" type="search" placeholder="Ex.: idLead, vlParcela, dtCadastro..."> -->

            <input id="fieldSearch" type="search" placeholder="Ex.: idLead, vlParcela, dtCadastro..."
              [value]="dictionarySearch2()" (input)="updateDictionarySearch2($any($event.target).value)">
          </label>

          <div class="table-wrapper data-dictionary">
            <table id="dictionaryTable">
              <thead>
                <tr>
                  <th>Campo JSON</th>
                  <th>Tipo e formato</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <tr [hidden]="!matchesDictionarySearch2('idLead','Número inteiro','Identificador único do lead')">
                  <td><code>idLead</code></td>
                  <td>Número - inteiro</td>
                  <td>Identificador único do lead.</td>
                </tr>
                <tr
                  [hidden]="!matchesDictionarySearch2('dtCadastro','Data - dd/MM/yyyy HH:mm:ss','Data e hora de criação')">
                  <td><code>dtCadastro</code></td>
                  <td>Data - dd/MM/yyyy HH:mm:ss</td>
                  <td>Data e hora de criação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('cdCampanha','Texto - até 20 caracteres','Código da campanha')">
                  <td><code>cdCampanha</code></td>
                  <td>Texto - até 20 caracteres</td>
                  <td>Código da campanha.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nmCampanha','Texto','Nome da campanha')">
                  <td><code>nmCampanha</code></td>
                  <td>Texto</td>
                  <td>Nome da campanha.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nmTipoCampanha','Texto','Tipo da campanha')">
                  <td><code>nmTipoCampanha</code></td>
                  <td>Texto</td>
                  <td>Tipo da campanha.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('idStatusLead','Texto','Status atual do lead')">
                  <td><code>idStatusLead</code></td>
                  <td>Texto</td>
                  <td>Status atual do lead.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('cdDn','Número - inteiro','Código da concessionária')">
                  <td><code>cdDn</code></td>
                  <td>Número - inteiro</td>
                  <td>Código da concessionária.</td>
                </tr>
                <tr
                  [hidden]="!matchesDictionarySearch2('cdCpfCnpj','Texto - 11 ou 14 dígitos','CPF ou CNPJ sem pontuação')">
                  <td><code>cdCpfCnpj</code></td>
                  <td>Texto - 11 ou 14 dígitos</td>
                  <td>CPF ou CNPJ sem pontuação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('tpPessoa','Texto','Física ou Jurídica')">
                  <td><code>tpPessoa</code></td>
                  <td>Texto</td>
                  <td>Física ou Jurídica.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nmNome', 'Texto','Nome completo do cliente')">
                  <td><code>nmNome</code></td>
                  <td>Texto</td>
                  <td>Nome completo do cliente.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtNascimento', 'Data - dd/MM/yyyy','Data de nascimento')">
                  <td><code>dtNascimento</code></td>
                  <td>Data - dd/MM/yyyy</td>
                  <td>Data de nascimento.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrCep', 'Texto - 8 dígitos','CEP sem hífen')">
                  <td><code>nrCep</code></td>
                  <td>Texto - 8 dígitos</td>
                  <td>CEP sem hífen.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('cdUf', 'Texto - 2 caracteres','Sigla do estado')">
                  <td><code>cdUf</code></td>
                  <td>Texto - 2 caracteres</td>
                  <td>Sigla do estado.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nmCidade', 'Texto - até 100 caracteres','Cidade')">
                  <td><code>nmCidade</code></td>
                  <td>Texto - até 100 caracteres</td>
                  <td>Cidade.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nmEmail', 'Texto - até 80 caracteres','Endereço de e-mail')">
                  <td><code>nmEmail</code></td>
                  <td>Texto - até 80 caracteres</td>
                  <td>Endereço de e-mail.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrDddCel', 'Número','DDD do celular')">
                  <td><code>nrDddCel</code></td>
                  <td>Número</td>
                  <td>DDD do celular.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrTelefoneCel', 'Número','Celular sem DDD')">
                  <td><code>nrTelefoneCel</code></td>
                  <td>Número</td>
                  <td>Celular sem DDD.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrDddRes', 'Número','DDD residencial')">
                  <td><code>nrDddRes</code></td>
                  <td>Número</td>
                  <td>DDD residencial.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrTelefoneRes', 'Número','Telefone residencial sem DDD')">
                  <td><code>nrTelefoneRes</code></td>
                  <td>Número</td>
                  <td>Telefone residencial sem DDD.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrDddCom', 'Número','DDD comercial')">
                  <td><code>nrDddCom</code></td>
                  <td>Número</td>
                  <td>DDD comercial.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrTelefoneCom', 'Número','Telefone comercial sem DDD')">
                  <td><code>nrTelefoneCom</code></td>
                  <td>Número</td>
                  <td>Telefone comercial sem DDD.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrDddAdi', 'Número','DDD adicional')">
                  <td><code>nrDddAdi</code></td>
                  <td>Número</td>
                  <td>DDD adicional.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrTelefoneAdi', 'Número','Telefone adicional')">
                  <td><code>nrTelefoneAdi</code></td>
                  <td>Número</td>
                  <td>Telefone adicional.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('idPrefContato', 'Texto','Preferência de contato')">
                  <td><code>idPrefContato</code></td>
                  <td>Texto</td>
                  <td>Preferência de contato.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsVendedor', 'Texto','Vendedor responsável')">
                  <td><code>dsVendedor</code></td>
                  <td>Texto</td>
                  <td>Vendedor responsável.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('flRenovacao', 'Texto','Indicador de renovação')">
                  <td><code>flRenovacao</code></td>
                  <td>Texto</td>
                  <td>Indicador de renovação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('flPreAprov', 'Texto','Status de pré-aprovação')">
                  <td><code>flPreAprov</code></td>
                  <td>Texto</td>
                  <td>Status de pré-aprovação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('pcPreAprovado', 'Decimal','Percentual de pré-aprovação')">
                  <td><code>pcPreAprovado</code></td>
                  <td>Decimal</td>
                  <td>Percentual de pré-aprovação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsMarca', 'Texto','Marca do veículo')">
                  <td><code>dsMarca</code></td>
                  <td>Texto</td>
                  <td>Marca do veículo.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsModeloCompleto', 'Texto','Modelo completo')">
                  <td><code>dsModeloCompleto</code></td>
                  <td>Texto</td>
                  <td>Modelo completo.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsModeloGrupo', 'Texto','Grupo do modelo')">
                  <td><code>dsModeloGrupo</code></td>
                  <td>Texto</td>
                  <td>Grupo do modelo.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsVersaoModelo', 'Texto','Versão do modelo')">
                  <td><code>dsVersaoModelo</code></td>
                  <td>Texto</td>
                  <td>Versão do modelo.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('cdMolicar', 'Texto','Código Molicar')">
                  <td><code>cdMolicar</code></td>
                  <td>Texto</td>
                  <td>Código Molicar.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('cdChassi', 'Texto','Chassi, quando informado')">
                  <td><code>cdChassi</code></td>
                  <td>Texto</td>
                  <td>Chassi, quando informado.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('tpUso', 'Texto','Novo, Seminovo ou Usado')">
                  <td><code>tpUso</code></td>
                  <td>Texto</td>
                  <td>Novo, Seminovo ou Usado.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrAnoFabVeic', 'Número','Ano de fabricação')">
                  <td><code>nrAnoFabVeic</code></td>
                  <td>Número</td>
                  <td>Ano de fabricação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('nrAnoModVeic', 'Número','Ano do modelo')">
                  <td><code>nrAnoModVeic</code></td>
                  <td>Número</td>
                  <td>Ano do modelo.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlPreco', 'Decimal','Preço do veículo')">
                  <td><code>vlPreco</code></td>
                  <td>Decimal</td>
                  <td>Preço do veículo.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlBem', 'Decimal','Valor do bem financiado')">
                  <td><code>vlBem</code></td>
                  <td>Decimal</td>
                  <td>Valor do bem financiado.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlEntrada', 'Decimal','Valor de entrada')">
                  <td><code>vlEntrada</code></td>
                  <td>Decimal</td>
                  <td>Valor de entrada.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('pcEntrada', 'Decimal','Percentual de entrada')">
                  <td><code>pcEntrada</code></td>
                  <td>Decimal</td>
                  <td>Percentual de entrada.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlFinanciado', 'Decimal','Valor total financiado')">
                  <td><code>vlFinanciado</code></td>
                  <td>Decimal</td>
                  <td>Valor total financiado.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlParcela', 'Decimal','Valor da parcela mensal')">
                  <td><code>vlParcela</code></td>
                  <td>Decimal</td>
                  <td>Valor da parcela mensal.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlParcResid', 'Decimal','Parcela residual')">
                  <td><code>vlParcResid</code></td>
                  <td>Decimal</td>
                  <td>Parcela residual.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlCartaCredito', 'Decimal','Valor da carta de crédito')">
                  <td><code>vlCartaCredito</code></td>
                  <td>Decimal</td>
                  <td>Valor da carta de crédito.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('qtPrazo', 'Número','Prazo em meses')">
                  <td><code>qtPrazo</code></td>
                  <td>Número</td>
                  <td>Prazo em meses.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlSimulacao', 'Decimal','Valor total da simulação')">
                  <td><code>vlSimulacao</code></td>
                  <td>Decimal</td>
                  <td>Valor total da simulação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtSimulacao', 'Data','Data e hora da simulação')">
                  <td><code>dtSimulacao</code></td>
                  <td>Data</td>
                  <td>Data e hora da simulação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsOrigemSimulacao', 'Texto','Origem da simulação')">
                  <td><code>dsOrigemSimulacao</code></td>
                  <td>Texto</td>
                  <td>Origem da simulação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('tpSegmento', 'Texto','Varejo ou Frota')">
                  <td><code>tpSegmento</code></td>
                  <td>Texto</td>
                  <td>Varejo ou Frota.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlMensalidadeAssinatura', 'Decimal','Mensalidade do plano')">
                  <td><code>vlMensalidadeAssinatura</code></td>
                  <td>Decimal</td>
                  <td>Mensalidade do plano.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('vlCustoTotalAssinatura', 'Decimal','Custo total do plano')">
                  <td><code>vlCustoTotalAssinatura</code></td>
                  <td>Decimal</td>
                  <td>Custo total do plano.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsPlano', 'Texto','Descrição do plano')">
                  <td><code>dsPlano</code></td>
                  <td>Texto</td>
                  <td>Descrição do plano.</td>
                </tr>
                <tr
                  [hidden]="!matchesDictionarySearch2('cdPropContrCot', 'Texto','Código da proposta, contrato ou cotação')">
                  <td><code>cdPropContrCot</code></td>
                  <td>Texto</td>
                  <td>Código da proposta, contrato ou cotação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtProposta', 'Data','Data e hora da proposta')">
                  <td><code>dtProposta</code></td>
                  <td>Data</td>
                  <td>Data e hora da proposta.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsStatusContrCot', 'Texto','Status do contrato ou cotação')">
                  <td><code>dsStatusContrCot</code></td>
                  <td>Texto</td>
                  <td>Status do contrato ou cotação.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtContrIni', 'Data','Início do contrato')">
                  <td><code>dtContrIni</code></td>
                  <td>Data</td>
                  <td>Início do contrato.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtContrLiq', 'Data','Liquidação do contrato')">
                  <td><code>dtContrLiq</code></td>
                  <td>Data</td>
                  <td>Liquidação do contrato.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtContrFim', 'Data','Encerramento do contrato')">
                  <td><code>dtContrFim</code></td>
                  <td>Data</td>
                  <td>Encerramento do contrato.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dtContemplacao', 'Data','Contemplação de consórcio')">
                  <td><code>dtContemplacao</code></td>
                  <td>Data</td>
                  <td>Contemplação de consórcio.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('cdDnAnterior', 'Número','DN anterior em remanejamento')">
                  <td><code>cdDnAnterior</code></td>
                  <td>Número</td>
                  <td>DN anterior em remanejamento.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsTextoLegal', 'Texto','Texto legal aceito pelo cliente')">
                  <td><code>dsTextoLegal</code></td>
                  <td>Texto</td>
                  <td>Texto legal aceito pelo cliente.</td>
                </tr>
                <tr [hidden]="!matchesDictionarySearch2('dsObs', 'Texto','Observações gerais')">
                  <td><code>dsObs</code></td>
                  <td>Texto</td>
                  <td>Observações gerais.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p id="dictionaryEmpty" class="empty-state" [hidden]="hasVisibleDictionaryRows()">
            Nenhum campo corresponde à pesquisa.
          </p>
        </section>

        <section id="transformacoes" class="doc-section">
          <h2>Transformações de valores</h2>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor retornado</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>tpPessoa</code></td>
                  <td>Física ou Jurídica.</td>
                </tr>
                <tr>
                  <td><code>flRenovacao</code></td>
                  <td>Sim ou Não.</td>
                </tr>
                <tr>
                  <td><code>flPreAprov</code></td>
                  <td>Sim, Não ou Não Solicitado.</td>
                </tr>
                <tr>
                  <td><code>tpUso</code></td>
                  <td>Novo, Seminovo ou Usado.</td>
                </tr>
                <tr>
                  <td><code>tpSegmento</code></td>
                  <td>Varejo ou Frota.</td>
                </tr>
                <tr>
                  <td>Datas gerais</td>
                  <td>dd/MM/yyyy HH:mm:ss.</td>
                </tr>
                <tr>
                  <td><code>dtNascimento</code></td>
                  <td>dd/MM/yyyy.</td>
                </tr>
                <tr>
                  <td>Campos vazios</td>
                  <td>String vazia <code>""</code>.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section id="erros" class="doc-section">
          <h2>Erros e tratamento</h2>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>HTTP</th>
                  <th>Erro</th>
                  <th>Ação recomendada</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span class="status status--warning">400</span></td>
                  <td><code>MISSING_TOKEN</code></td>
                  <td>Adicionar o header <code>x-api-key</code>.</td>
                </tr>
                <tr>
                  <td><span class="status status--warning">400</span></td>
                  <td>Paginação inválida</td>
                  <td>Usar página a partir de 1 e entre 1 e 200 resultados.</td>
                </tr>
                <tr>
                  <td><span class="status status--error">403</span></td>
                  <td><code>INVALID_TOKEN</code></td>
                  <td>Verificar se o token está válido, ativo e não expirou.</td>
                </tr>
                <tr>
                  <td><span class="status status--error">403</span></td>
                  <td><code>DN_NOT_AUTHORIZED</code></td>
                  <td>Consultar somente DNs vinculadas ao token.</td>
                </tr>
                <tr>
                  <td><span class="status status--error">500</span></td>
                  <td>Erro interno</td>
                  <td>Registrar o horário e acionar o suporte VWFS.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>Formato do erro</h3>

          <div class="code-panel">
            <div class="code-panel__header">
              <span>JSON</span>
              <button class="copy-button" type="button" (click)="copyCode($event)">Copiar</button>
            </div>

            <pre><code ngNonBindable>
  "error": "CODIGO_DO_ERRO",
  "message": "Descrição do problema",
  "timestamp": "2026-04-23T14:30:00Z"
</code></pre>
          </div>
        </section>

        <section id="deduplicacao" class="doc-section">
          <h2>Deduplicação e atualização</h2>

          <div class="notice notice--success">
            Use exclusivamente <code>idLead</code> como chave de deduplicação.
            Não deduplique por CPF ou CNPJ.
          </div>

          <ul class="feature-list">
            <li>
              Um <code>idLead</code> existente somente pode receber atualização
              relacionada a Simulação Online.
            </li>
            <li>
              Essa atualização pode ocorrer por até uma hora após novas
              simulações realizadas pelo próprio lead.
            </li>
            <li>
              Um CPF pode aparecer várias vezes, associado a leads ou contratos
              diferentes.
            </li>
            <li>
              Não existe data de consulta na resposta para ser usada como
              critério de deduplicação.
            </li>
            <li>
              O status não é atualizado por integrações externas.
            </li>
          </ul>
        </section>

        <section id="frequencia" class="doc-section">
          <h2>Frequência de consulta</h2>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Origem</th>
                  <th>Atualização</th>
                  <th>Orientação</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Simulação Online</td>
                  <td>Tempo real</td>
                  <td>Adequar o intervalo à necessidade operacional do CRM.</td>
                </tr>
                <tr>
                  <td>Proposta Aprovada</td>
                  <td>Diariamente, a partir das 08:00</td>
                  <td>Agendar a consulta após a atualização diária.</td>
                </tr>
                <tr>
                  <td>Período de Recompra</td>
                  <td>Diariamente, a partir das 08:00</td>
                  <td>Agendar a consulta após a atualização diária.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section id="faq" class="doc-section">
          <h2>Perguntas frequentes</h2>

          <div class="accordion">
            <details open>
              <summary>É possível consultar leads retroativos?</summary>
              <p>
                Sim. O documento informa filtros por intervalo de datas,
                aplicados à data de cadastro do lead.
              </p>
            </details>

            <details open>
              <summary>Qual é a ordenação padrão?</summary>
              <p>
                Do registro mais recente para o mais antigo, com desempate pelo
                identificador do lead em ordem decrescente.
              </p>
            </details>

            <details open>
              <summary>Existe filtro por status?</summary>
              <p>
                Não. A documentação cita filtros por DN, CPF/CNPJ, leadId,
                campanha e período, mas não define as URLs de CPF/CNPJ, leadId
                e campanha.
              </p>
            </details>

            <details open>
              <summary>É possível alterar o status pela API?</summary>
              <p>
                Não. A operação de atualização existe no backend interno, mas
                não é publicada para integrações externas.
              </p>
            </details>
          </div>
        </section>

        <section id="historico" class="doc-section">
          <h2>Histórico de versões</h2>

          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Versão</th>
                  <th>Data</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0.1</td>
                  <td>28/04/2026</td>
                  <td>Documento inicial.</td>
                </tr>
                <tr>
                  <td>0.2</td>
                  <td>04/05/2026</td>
                  <td>Exemplos complementares de filtro.</td>
                </tr>
                <tr>
                  <td>0.3</td>
                  <td>18/06/2026</td>
                  <td>Filtro por data e perguntas frequentes.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section id="contato" class="doc-section">

          <h2>Contato e disponibilização de credenciais</h2>

          <p class="lead">Para solicitação dos dados de configuração dos clientes (DN) e dos respectivos tokens de
            acesso à API, entre em contato com:</p>

          <h4 style="font-size: 19px;">Contato principal:</h4>
          <p style="font-size: 16px;" class="lead">
            <b>Thamara Iglesias Berni</b> – thamara.berni@vwfs.com
          </p>

          <h4 style="font-size: 19px;">Contato de contingência:</h4>
          <p style="font-size: 16px;" class="lead">
            <b>André Moretto</b> – andre.moretto@vwfs.com
          </p>
        </section>

        <footer class="footer">
          <p>
            API de Integração de Leads - documentação estática.
            Não inclua tokens ou dados pessoais reais neste site.
          </p>
        </footer>
      </div>

      <aside class="toc" aria-label="Nesta página">
        <strong>Nesta página</strong>
        <nav id="pageToc"></nav>
      </aside>
    </main>
  </div>

  <div id="toast" class="toast" role="status" aria-live="polite">
    Copiado.
  </div>
